module.exports = __webpack_public_path__ + "static/14-32AFB44F-6C4F-47A5-B45F-4C4E17A96688-d292c48dedecf7ae45c2b74e983fdf16.jpg";